













import {Component, Prop, PropSync, Vue} from 'vue-property-decorator'
import { DxSwitch } from 'devextreme-vue/switch';
import {
  DxValidator,
  DxRequiredRule,
  DxEmailRule,
  DxStringLengthRule
} from 'devextreme-vue/validator';

@Component({
  name: 'DSwitch',
  components: {
    DxSwitch,
    DxValidator,
    DxRequiredRule,
    DxEmailRule,
    DxStringLengthRule
  }
})
export default class extends Vue {

  @PropSync('inputData') synceInputData!: boolean
  @Prop({ default: '' }) public title!: string;
  @Prop({ default: false }) public disabled!: boolean;

  created() {

  }


}
